import {
  PROJECT_FETCH_SUCCESS,
  PROJECT_FETCH_FAIL,
  SET_CURRENT_PROJECT,
  PROJECT_CREATE_SUCCESS,
  PROJECT_DELETE_SUCCESS,
  PROJECT_UPDATE_SUCCESS
} from '../constant/actionType';
import logger from '../util/logger';

export const initialState = {
  currentProject: null,
  projects: []
};

const customTypeReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case PROJECT_FETCH_SUCCESS: {
      logger.debug(`${PROJECT_FETCH_SUCCESS}: ${JSON.stringify(data)}`);
      const { projects } = data;

      return { ...state, projects };
    }

    case PROJECT_FETCH_FAIL: {
      logger.debug(`${PROJECT_FETCH_FAIL}`);

      return { ...state };
    }

    case SET_CURRENT_PROJECT: {
      logger.debug(`${SET_CURRENT_PROJECT}: ${JSON.stringify(data)}`);

      const project = data;

      return { ...state, currentProject: project };
    }

    case PROJECT_CREATE_SUCCESS: {
      logger.debug(`${PROJECT_CREATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { project } = data;
      const { projects } = state;
      projects.unshift(project);

      return { ...state, projects: [...projects] };
    }

    case PROJECT_UPDATE_SUCCESS: {
      logger.debug(`${PROJECT_UPDATE_SUCCESS}: ${JSON.stringify(data)}`);

      const { projects } = state;

      const selectedProject = projects.filter((project) => project._id === data._id);

      const index = projects.indexOf(selectedProject[0]);
      projects[index].languages = data.languages;

      return { ...state, projects: [...projects] };
    }

    case PROJECT_DELETE_SUCCESS: {
      logger.debug(`${PROJECT_DELETE_SUCCESS}: ${JSON.stringify(data)}`);

      const id = data;
      const { projects } = state;
      const newProjects = projects.filter((project) => project._id !== id);

      return { ...state, projects: [...newProjects] };
    }

    default:
      return state;
  }
};

export default customTypeReducer;
